import PropTypes from 'prop-types';
import { Stack, Typography, useTheme } from '@mui/material';

const styles = {
  container: (_, background) => {
    return {
      width: '100%',
      gap: 1,
      padding: 1,
      borderRadius: 2.5,
      background,
    };
  },
};

const Info = ({
  customStyles = null,
  title = '',
  titleDescription = '',
  subTitle = '',
  description = '',
  variant = 'normal',
  withPlusSign = false,
  isRowDirection = false,
  isComparison = false,
}) => {
  const {
    palette: {
      text,
      colors: { lightPale, statusRed, statusYellow, statusGreen },
    },
  } = useTheme();

  const colorsByVariant = {
    normal: { background: lightPale, text: text.primary },
    danger: { background: statusRed, text: text.secondary },
    warning: { background: statusYellow, text: text.secondary },
    success: { background: statusGreen, text: text.secondary },
  }[variant];

  const textColor = colorsByVariant?.text;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction={isRowDirection ? 'row' : 'column'}
      sx={[(theme) => styles.container(theme, colorsByVariant?.background), customStyles]}
    >
      {subTitle && (
        <Typography variant="body2" color={textColor} textAlign="center">
          {subTitle}
        </Typography>
      )}

      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Typography variant="h2-bold" color={textColor} textAlign="center" component="p">
          {`${withPlusSign ? '+' : ''}${title}`}
        </Typography>

        {titleDescription && (
          <Typography variant="body1" color={textColor}>
            {titleDescription}
          </Typography>
        )}
      </Stack>

      {description && (
        <Typography textAlign="center" variant="caption" color={textColor}>
          {description}
        </Typography>
      )}

      {isComparison && !description && (
        <Typography textAlign="center" variant="caption" color={textColor}>
          Compared
          <br />
          to previous
        </Typography>
      )}
    </Stack>
  );
};

Info.propTypes = {
  customStyles: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  title: PropTypes.string,
  titleDescription: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.string,
  subTitle: PropTypes.string,
  withPlusSign: PropTypes.bool,
  isRowDirection: PropTypes.bool,
  isComparison: PropTypes.bool,
};
export default Info;
